module.exports = __webpack_public_path__ + "img/Mask-Watercolor-2.b4480785.png";